import { FormCardLang } from './card/formCard.lang';

export const FormsLang = {
    card: FormCardLang,
    page: {
        newForm: 'فرم جديد',
        listForm: 'ليست انتشارها',
        emptyState: 'در حال حاضر هیچ فرم فعالی برای انتشار توسط شما وجود ندارد',
    },
};
